import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {TokenStorageService} from '../services/token-storage.service';
import {UserPositionEnum} from '../../../shared/enums/user-position.enum';

@Injectable({
  providedIn: 'root'
})

export class NotPaidGuard implements CanActivate {

  constructor(
    private router: Router,
    public tokenStorageService: TokenStorageService
  ) {}

  canActivate(): Observable<boolean> {
    // Support employees retain full access regardless of payment
    // status (JOB-3866) - they're the ones who need to get in to help a
    // past-due customer resolve their account, so locking them out too
    // would defeat the purpose.
    const userProfile = this.tokenStorageService.getUser();
    const isJobatorySupport = userProfile?.positions?.findIndex(
      p => p.position === UserPositionEnum.JobatorySupport
    ) > -1;
    if (isJobatorySupport) {
      return of(true);
    }

    const packagePaymentStatus = this.tokenStorageService.getPackagePaymentStatus();
    if (packagePaymentStatus.packagePaymentStatus === 'not_paid' && packagePaymentStatus.unpaidDays > 30) {
      this.router.navigate(['/my-info/payment-method']);
    }
    return of(true);
  }

}
